import React, { CSSProperties, ReactElement, ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { Button, BUTTON_COLOR } from '../../atoms'
import { Modal } from '../../molecules'

export interface IModalCreateProps {
  isOpen: boolean
  closeModal: () => void
  title?: string | ReactElement
  children: ReactNode
  footer?: (() => React.ReactNode) | undefined
  submit: () => void
  disabled: boolean
  loading: boolean
  width?: string
  height?: string
  error?: string
  scrollbarStyle?: CSSProperties
  footerStyle?: CSSProperties
  customHeader?: ReactNode
  aboveCustomFooter?: React.ReactElement
  leftCustomFooter?: React.ReactElement
  noScroll?: boolean
  confirmButtonLabel?: string
  disableOnClose?: boolean
  className?: string
}

const ModalCreate = ({
  isOpen,
  closeModal,
  title,
  customHeader,
  children,
  submit,
  disabled,
  loading,
  width,
  height,
  error,
  scrollbarStyle,
  footerStyle,
  aboveCustomFooter,
  leftCustomFooter,
  noScroll,
  confirmButtonLabel,
  disableOnClose = false,
  className,
}: IModalCreateProps) => {
  return (
    <Modal
      isOpen={isOpen}
      closeModal={!disableOnClose ? closeModal : undefined}
      title={title}
      customHeader={customHeader}
      renderButtons={() => (
        <div className={s.containerFooter}>
          {aboveCustomFooter}
          <div
            className={s.footer}
            style={{
              justifyContent: leftCustomFooter ? 'space-between' : 'end',
            }}
          >
            {leftCustomFooter}
            {error && <div className={s.form__error}>{error}</div>}
            <div className={s.buttonWrapper}>
              <Button
                color={BUTTON_COLOR.LIGHT_GREY}
                style={{ marginRight: '15px' }}
                onClick={!disableOnClose ? closeModal : undefined}
              >
                <FormattedMessage
                  id='ui.modal.cancel'
                  defaultMessage='Annuler'
                />
              </Button>
              <Button
                onClick={submit}
                disabled={disabled}
                loading={loading}
                data-testid='save-button'
              >
                {confirmButtonLabel ?? (
                  <FormattedMessage
                    id='ui.modal.confirm'
                    defaultMessage='Enregistrer'
                  />
                )}
              </Button>
            </div>
          </div>
        </div>
      )}
      className={className}
      style={{
        width: width ? width : '40vw',
        maxHeight: '90vh',
        height: height || 'auto',
        padding: '0px',
      }}
      styleHeader={{ borderBottom: '1px solid var(--border)' }}
      footerStyle={{ padding: 0, ...footerStyle }}
      styleChildren={{ padding: '0' }}
      scrollbarStyle={scrollbarStyle}
      noScroll={noScroll}
    >
      {children}
    </Modal>
  )
}

export default ModalCreate
